// ── SHARED CONSTANTS ─────────────────────────────────────────────────────────
export const API_BASE = import.meta.env.VITE_API_URL || 'https://sykessedation.co.uk/api';
export const EM = 'sykessedation@gmail.com';
export const ADDR = '3 Church Gardens, London, W5 4HH';
export const CO = '9261408';
